
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-video{
  display:inline-flex;
  flex-direction:column;
  max-width:60vw;
  aspect-ratio:16 / 9;
  cursor:pointer;
}

  .se-video figcaption{
    display:table-caption;
    caption-side:bottom;
    padding-top:var(--spacing-5);
  }

  .se-video .video{
    display:flex;
    width:100%;
    position:relative;
  }

  .se-video .video .play-btn{
      display:flex;
      justify-content:center;
      align-items:center;
      height:6rem;
      width:6rem;
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%, -50%);
      color:var(--brand-neutral-white);
      border:none;
      border-radius:100%;
      background:rgba(0, 0, 0, 0.3);
    }

  .se-video .video .play-btn.hidden{
        display:none;
      }

  .se-video .video > iframe,
    .se-video .video > video,
    .se-video .video > div,
    .se-video .video ::slotted(iframe),
    .se-video .video ::slotted(video),
    .se-video .video ::slotted(div){
      width:100%;
      aspect-ratio:16 / 9;
    }

  .se-video .video:hover .play-btn{
        color:var(--brand-neutral-gray-600);
        background:rgba(255, 255, 255, 0.7);
      }
`;